import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ContextService } from '../context.service';

@Component({
  selector: 'mutara-progress-indicator',
  template: `
    <div *ngIf='showProgress' class='display-flex align-items-center'>
      <span class='mutara-sm-strong' [attr.aria-label]="'Application progress, ' + progress + ' percent complete'">{{label}}</span>
      <mat-progress-bar [value]="progress" [mode]="indeterminate ? 'indeterminate' : 'determinate'" 
        class="mutara-progress-bar"></mat-progress-bar>
    </div>
    `,
  standalone: false
})
export class ProgressIndicatorComponent implements OnInit {
  @Input() label: string = 'Progress';
  progress: number = 0;
  indeterminate: boolean = false;
  showProgress: boolean = false;

  constructor(private contextSettings: ContextService) { }

  ngOnInit(): void {
    this.contextSettings.subscribeTo("showProgressValue", (visible: boolean) => {
      setTimeout(() => {
        this.showProgress = visible;
      }, 0); // Make this async to prevent error
    });

    this.contextSettings.subscribeTo("percentComplete", (complete: number) => {
      setTimeout(() => {
        this.progress = complete;
      }, 0); // This this async 
    });
    this.contextSettings.subscribeTo("indeterminateProgress", (indeterminate: boolean) => {
      setTimeout(() => {
        this.indeterminate = indeterminate;
      }, 0);
    });
  }
}